/* F-04 bookings list: one card per reservation, journeys as two ends and a line. */
.page {
  max-width: 920px;
  padding-bottom: var(--dimension-space-8);
}
.pad {
  padding: var(--dimension-space-4) var(--dimension-space-5);
}
.muted {
  color: var(--color-text-secondary);
}
.top {
  padding: var(--dimension-space-4) var(--dimension-space-5);
  border-bottom: var(--dimension-line-hairline) solid var(--color-border-hairline);
}
.title {
  margin: 0;
}
.notice {
  margin: 0;
  padding: var(--dimension-space-2) var(--dimension-space-5);
  background: var(--color-surface-sunken);
}
.cards {
  display: grid;
  gap: var(--dimension-space-3);
  margin: 0;
  padding: var(--dimension-space-4) var(--dimension-space-5);
  list-style: none;
}
.card {
  display: grid;
  grid-template-columns: 88px 1fr;
  background: var(--color-surface-raised);
  border: var(--dimension-line-hairline) solid var(--color-border-hairline);
}
.kind {
  display: grid;
  justify-items: center;
  align-content: start;
  gap: var(--dimension-space-1);
  padding: var(--dimension-space-4) var(--dimension-space-2);
  background: var(--color-surface-inverse);
  color: var(--color-text-on-inverse);
}
.body {
  display: grid;
  gap: var(--dimension-space-3);
  padding: var(--dimension-space-4);
  min-width: 0;
}
.head {
  display: flex;
  align-items: center;
  gap: var(--dimension-space-3);
}
.name {
  flex: 1;
  margin: 0;
}
.conf {
  border: 0;
  background: none;
  padding: 0;
  cursor: copy;
}
.icon {
  border: 0;
  background: none;
  color: var(--color-text-tertiary);
  cursor: pointer;
  padding: var(--dimension-space-1);
}
.icon:hover {
  color: var(--color-text-primary);
}
.journey {
  display: grid;
  grid-template-columns: auto 1fr auto;
  align-items: center;
  gap: var(--dimension-space-4);
}
.end {
  display: grid;
  gap: 2px;
}
.right {
  text-align: right;
}
.line {
  position: relative;
  text-align: center;
  padding-bottom: var(--dimension-space-2);
  border-bottom: var(--dimension-line-control) solid var(--color-text-primary);
}
.when {
  display: block;
}
.tags,
.files {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--dimension-space-2);
}
.file {
  display: inline-flex;
  align-items: center;
  gap: var(--dimension-space-1);
  color: var(--color-text-primary);
}
.detailGrid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: var(--dimension-space-3);
}
